import React, { useState, useEffect } from "react";
import "./hero.css";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitType from "split-type";
import Button from "../button/Button";
import ContactUsForm from "./ContactUsForm";
import {Link} from 'react-router-dom'

const Hero = () => {
  const [showForm, setShowForm] = useState(false);

  const toggleForm = () => {
    setShowForm((prev) => !prev);
  };

  // useEffect(() => {
  //   Aos.init();
  //   Aos.refresh();
  // }, []);
  return (
    <>
      <video
        src="/Digital_Grapes.mp4"
        autoPlay
        loop
        muted
        className="video w-full h-screen object-cover fixed top-0 opacity-50"
      ></video>
      <div className="main_hero" id="home">
        <div className="hero_content_holder_container relative">
          <div className="hero_content_container">
            <h1 className="content font-bold">
              Logos are designed in studios.
              <br /> Brands are created in minds.
            </h1>
            <p>Get a free consultation with our branding experts.</p>
            <Link to="/contact">
            <button className="hero_btn">
              Contact Now
            </button>
            </Link>
          </div>
          {/* <a
          href="https://wa.me/9765978888"
          className="border-2 border-green-500 rounded-full py-2 px-4 md:hidden my-5"
          target="_blank"
          rel="noopener noreferrer"
        >
          <WhatsAppIcon className="whatsapp_icon" />
          WhatsApp Us
        </a>
        <div className="scroll_animation">
          <span className="scroll_down"></span>
          <p>Scroll Down</p>
        </div> */}
        </div>
        {showForm && <ContactUsForm setShowForm={setShowForm} />}
      </div>
    </>
  );
};

export default Hero;
